import {
  LoadLanguages,
  LoadLanguagesCompleted,
  LoadLanguagesFailed,
} from './language-load.action';

export { LanguageActionType } from './language-action-type.enum';

export {
  LoadLanguages,
  LoadLanguagesCompleted,
  LoadLanguagesFailed,
} from './language-load.action';

export type LanguageActions =

  LoadLanguages |
  LoadLanguagesCompleted |
  LoadLanguagesFailed;
